export default __webpack_public_path__ + "static/media/자율성.cc1a8bd9.png";